"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_2 = require("@connect2ic/react");
const authProvider_1 = require("../authProvider/authProvider");
const origyn_art_ui_1 = require("@origyn/origyn-art-ui");
const styled_components_1 = __importDefault(require("styled-components"));
const react_router_dom_1 = require("react-router-dom");
const ExternalLogin = () => {
    const { open: openLogin } = (0, react_2.useDialog)();
    const { loggedIn, principal, handleLogOut } = (0, react_1.useContext)(authProvider_1.AuthContext);
    const [isMenuOpened, setIsMenuOpened] = (0, react_1.useState)(false);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const ref = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                setIsMenuOpened(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);
    const handleLogIn = () => {
        if (window.location.hostname.includes("dashboard")) {
            window.location.href = "https://governance.origyn.network/login";
        }
        else {
            openLogin();
        }
    };
    return (loggedIn ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(StyledWalletMenu, null,
            react_1.default.createElement(StyledWallet, { size: "small", onClick: () => setIsMenuOpened(!isMenuOpened) },
                react_1.default.createElement(origyn_art_ui_1.Icons.ProfileIcon, { style: { marginLeft: '-6px', width: 16 } }),
                principal.toString().substring(3, 0),
                "...",
                principal.toString().substring(principal.toString().length - 3)),
            handleLogOut && isMenuOpened && (react_1.default.createElement(StyledLogOut, { ref: ref, type: "filled", padding: "16px" },
                react_1.default.createElement(origyn_art_ui_1.Flex, null,
                    react_1.default.createElement(origyn_art_ui_1.Button, { textButton: true, size: "small", onClick: () => { handleLogOut(); navigate('/'); } }, "Log out"))))))) : (react_1.default.createElement(origyn_art_ui_1.Button, { onClick: handleLogIn, role: "button" }, "Login")));
};
exports.default = ExternalLogin;
const StyledWalletMenu = (0, styled_components_1.default)("div") `
  position: relative;
`;
const StyledLogOut = (0, styled_components_1.default)(origyn_art_ui_1.Card) `
  position: absolute;
  top: 100%;
  right: 0;
  width: 100%;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const StyledWallet = (0, styled_components_1.default)(origyn_art_ui_1.Button) `
  position: relative;
  background: ${({ theme }) => theme.colors.BACKGROUND};
  border: 1px solid ${({ theme }) => theme.colors.BORDER};
  color: ${({ theme }) => theme.colors.TEXT};
  opacity: 1;

  &:after {
    content: "";
    display: block;
    position: absolute;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    top: 0;
    right: 0;

    background: ${({ theme }) => theme.colors.SUCCESS};

    border: 1px solid #000000;
  }
`;
